// NavLinks.tsx
import React from 'react';
import { NavLink } from 'react-router-dom';
import { Building, Users, CreditCard, UserCog } from 'lucide-react';

interface NavLinksProps {
  isMobile?: boolean;
  onItemClick?: () => void;
}

export const NavLinks: React.FC<NavLinksProps> = ({ isMobile = false, onItemClick }) => {
  const baseClasses = "flex items-center gap-2 px-3 py-2 rounded-full transition-colors";
  const activeClasses = "bg-primary text-white dark:bg-primary-dark dark:text-primary-foreground";
  const inactiveClasses = "bg-ghost text-muted-foreground hover:text-foreground";

  const handleClick = () => {
    if (isMobile && onItemClick) {
      onItemClick();
    }
  };

  return (
    <>
      <NavLink 
        to="/organizations" 
        className={({ isActive }) => `${baseClasses} ${isActive ? activeClasses : inactiveClasses}`} 
        onClick={handleClick}
      >
        <Building className="h-5 w-5" />
        <span>Organizations</span>
      </NavLink>
      <NavLink 
        to="/users" 
        className={({ isActive }) => `${baseClasses} ${isActive ? activeClasses : inactiveClasses}`} 
        onClick={handleClick}
      >
        <Users className="h-5 w-5" />
        <span>Users</span>
      </NavLink>
      <NavLink 
        to="/plans" 
        className={({ isActive }) => `${baseClasses} ${isActive ? activeClasses : inactiveClasses}`} 
        onClick={handleClick}
      >
        <CreditCard className="h-5 w-5" />
        <span>Plans</span>
      </NavLink>
      <NavLink 
        to="/system-users" 
        className={({ isActive }) => `${baseClasses} ${isActive ? activeClasses : inactiveClasses}`} 
        onClick={handleClick}
      >
        <UserCog className="h-5 w-5" />
        <span>System Users</span>
      </NavLink>
    </>
  );
};